// GENERATED by scripts/gen-hooks.mjs. Do not edit by hand.
// 9 hooks for backend/operator.

import { useBackend } from '../useBackend'

/** POST /api/operator/acceptOperatorInstruction */
export function useAcceptOperatorInstruction<T = any>() {
  return useBackend<T>('operator/acceptOperatorInstruction')
}

/** POST /api/operator/bindOperatorMetric */
export function useBindOperatorMetric<T = any>() {
  return useBackend<T>('operator/bindOperatorMetric')
}

/** POST /api/operator/getOperatorBoard */
export function useGetOperatorBoard<T = any>() {
  return useBackend<T>('operator/getOperatorBoard')
}

/** POST /api/operator/getOperatorInstruction */
export function useGetOperatorInstruction<T = any>() {
  return useBackend<T>('operator/getOperatorInstruction')
}

/** POST /api/operator/getOperatorSeries */
export function useGetOperatorSeries<T = any>() {
  return useBackend<T>('operator/getOperatorSeries')
}

/** POST /api/operator/pasteOperatorInstruction */
export function usePasteOperatorInstruction<T = any>() {
  return useBackend<T>('operator/pasteOperatorInstruction')
}

/** POST /api/operator/previewOperatorInstruction */
export function usePreviewOperatorInstruction<T = any>() {
  return useBackend<T>('operator/previewOperatorInstruction')
}

/** POST /api/operator/refreshOperatorMeasures */
export function useRefreshOperatorMeasures<T = any>() {
  return useBackend<T>('operator/refreshOperatorMeasures')
}

/** POST /api/operator/unbindOperatorMetric */
export function useUnbindOperatorMetric<T = any>() {
  return useBackend<T>('operator/unbindOperatorMetric')
}
